<template>
  <div class="wrap">
    <div class="wrapper">
      <banners class="curr-banner"></banners>
      <div class="wrap-content">
        <div class="page-title">
          <div class="title">
            <a>招聘公示</a>
          </div>
        </div>
        <div class="page-body">
          <div class="content">
            <!-- 标题区域 -->
            <div class="title-wrap">
              <div class="main-title">{{ content.title }}</div>
              <div class="sub-title">
                <span>来源：</span><span>{{ content.source }}</span>
                <span> 发布日期：</span><span>{{ content.rlsdate }}</span>
              </div>
            </div>
            <div>
              <p class="right-html-content" style="line-height: 28px; margin-right: 20px;" v-html="content.content"></p>
              <div class="no-copy" @copy.prevent @selectstart.prevent>
                <el-table v-show="(content.notice == '公示')" :data="tableData" border
                  :header-cell-style="{ 'background-color': '#f2f2f2' }" class="center-table">

                  <el-table-column v-for="column in fields" :key="column.fieldname" :prop="column.fieldname"
                    :label="column.fieldalias" align="center" :width="column.fieldwidth">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 附件 -->
            <div class="right-accessory" v-show="accessorys && accessorys.length > 0">
              <div class="foot-title"><span>附件</span></div>
              <ul class="body">
                <li v-for="item in accessorys" v-bind:key="item.oid" @click="downloadFile(item.oid)">
                  <a>{{ item.filename }}</a> <span>{{ item.filesize }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
import banners from "../../common/banner";
import { recruiData, downfile } from "../../request/api.js";
export default {
  components: {
    banners,
  },
  name: "home",
  data() {
    return {
      content: {},
      select: "招聘公示",
      noticeName: "",
      tableData: [],
      fields: [],
      // 附件
      accessorys: [],
    };
  },
  mounted() {
    this.initData(this.$route.query.id);
  },
  methods: {
    initData(id) {
      recruiData(id).then((res) => {
        // console.log(res);
        this.content = res.data.announcement;
        // 附件
        this.accessorys = res.data.accessory;
        if (res.data.tableData) {
          this.tableData = res.data.tableData;
          this.fields = res.data.fields;
        }
      });
    },
    link() {
      this.$router.push("/ofPublicList");
    },
    downloadFile(oid) {
      // 下载文件
      this.accessorys.forEach((item) => {
        if (item.oid == oid) {
          var params = {
            isWeb: "true",
            isYES2: "true",
            mode: "1",
            oid: item["oid"],
            service: "DownloadAttachment",
            path: item["filepath"],
            formKey: item["formKey"],
          };
          downfile(params).then((res) => {
            if (res) {
              const url = window.URL.createObjectURL(res);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", item["filename"]);
              document.body.appendChild(link);
              link.click();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 40px;

    .curr-banner {
      margin-bottom: 24px;
      height: 128px;

      ::v-deep {
        .el-carousel .img-item {
          display: block;
          height: 128px;
          width: 100%;
        }

        .el-carousel__button {
          width: 12px;
        }

        .el-carousel .el-carousel__container {
          height: 128px;
        }
      }
    }
  }

  .wrap-content {
    margin: 0 auto;

    .page-title {
      background: #fff;
      line-height: 48px;
      margin-bottom: 12px;

      .title a {
        margin-left: 16px;
        position: relative;
      }

      .title a::after {
        position: absolute;
        top: 0;
        left: -8px;
        bottom: 0;
        content: "";
        width: 4px;
        background: #0089d0;
      }
    }

    .page-body {
      display: flex;
    }

    .content {
      // flex: auto;
      background: #fff;
      padding: 12px;
      min-height: 150px;

      .right-html-content {
        text-indent: 24px;
      }
    }

    .title-wrap {
      .main-title {
        font-size: 24px;
        text-align: center;
        overflow-wrap: break-word;
        margin-bottom: 12px;
        font-weight: bold;
      }

      .sub-title {
        line-height: 1.5;
        font-size: 14px;
        text-align: center;
        overflow-wrap: break-word;
      }
    }

    .right-accessory {
      .foot-title {
        height: 40px;
        line-height: 40px;
        font-size: 18px;

        span {
          padding-left: 12px;
          border-left: 4px solid#23a6de;
        }
      }

      .body {
        list-style: none;
        display: block;

        li {
          display: block;
          cursor: pointer;
          margin-bottom: 12px;

          a {
            display: inline-block;
            font-size: 14px;
            padding: 12px;
            color: #01539f;
            vertical-align: baseline;
          }

          span {
            font-size: 12px;
            display: inline-block;
            vertical-align: baseline;
          }
        }

        li:hover {
          background: #eee;
        }

        li:active {
          opacity: 0.5;
        }
      }
    }
  }
}

.border {
  width: 100%;
  height: 40px;
}

.no-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media screen and (min-width: 480px) {}

/* 移动 */
@media screen and (min-width: 576px) {
  .wrap {
    .wrapper {

      // curr-banner
      .curr-banner {
        height: 154px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 154px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 154px;
          }
        }
      }

      // curr-banner
    }
  }
}

/* 平板 */
@media screen and (min-width: 768px) {
  .wrap {
    .wrapper {

      // curr-banner
      .curr-banner {
        height: 204px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 204px;
            width: 100%;
          }

          .el-carousel__button {
            width: 30px;
          }

          .el-carousel .el-carousel__container {
            height: 204px;
          }
        }
      }
    }

    .wrap-content {
      .let-tab-nav {
        display: block;
      }

      .right-content {
        margin-left: 12px;
      }
    }

    // post-content
    .post-content {
      display: none;
    }
  }
}

/* PC */
@media screen and (min-width: 992px) {
  .wrap {
    .wrapper {

      // curr-banner
      .curr-banner {
        height: 260px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 260px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 260px;
          }
        }
      }

      // curr-banner
    }
  }
}

@media screen and (min-width: 1200px) {
  .wrap {
    .wrapper {
      padding-left: 0;
      padding-right: 0;

      .curr-banner {
        height: 320px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 320px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 320px;
          }
        }
      }
    }

    // banner-type
    .banner-type {
      height: 320px;
      margin-left: 24px;
      margin-right: 24px;
    }

    // banner-type

    .wrap-content {
      width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
